// @flow
import ordinal from 'ordinal-number-suffix';

const getDisplayRank = (rank: number): string => rank ? ordinal(rank) : '-';

export default getDisplayRank;


// WEBPACK FOOTER //
// ./src/helpers/getDisplayRank.js